import { ComponentProps } from "react";
import { styled } from "~/application/theme";

export type CounterTabBadgeProps = ComponentProps<typeof CounterTabBadge>;

export const CounterTabBadge = styled("span", {
  // Reset
  boxSizing: "border-box",
  display: "inline-block",

  // Custom
  borderRadius: "$md",
  fontWeight: 700,
  fontSize: "$xxs",
  lineHeight: "1",
  padding: "$1",
  color: "$primary-dark",
  backgroundColor: "$primary-light",
});
